export default "__VITE_ASSET__9f6ba3f1__"